import { LegalPageLayout } from './LegalPageLayout';

export function ComeSelezioniamoPage() {
  return (
    <LegalPageLayout title="Come Selezioniamo i Consulenti">
      <p className="mt-2 text-sm text-neutral-500">Ultima revisione: 7 Maggio 2026</p>
                  
                    <p>
                      Su Klaro7 la qualità delle consulenze è uno degli aspetti più importanti della
                      piattaforma. Per questo motivo la selezione dei consulenti avviene attraverso un
                      processo attento che mira a garantire professionalità, correttezza e rispetto degli
                      utenti.
                    </p>
                    <p>
                      Il nostro obiettivo è offrire un ambiente affidabile in cui gli utenti possano
                      confrontarsi con consulenti seri e preparati.
                    </p>
      
                    <h2>Un processo di selezione attento</h2>
                    <p>
                      Non tutti i candidati che richiedono di collaborare con Klaro7 vengono
                      automaticamente accettati.
                    </p>
                    <p>
                      Ogni richiesta di collaborazione viene valutata attentamente tenendo conto di diversi
                      elementi, tra cui:
                    </p>
                    <ul>
                      <li>esperienza nel settore della cartomanzia</li>
                      <li>capacità di ascolto e comunicazione</li>
                      <li>approccio rispettoso verso l&apos;utente</li>
                      <li>disponibilità a operare secondo le regole della piattaforma</li>
                    </ul>
                    <p>Questo processo ci permette di mantenere standard professionali elevati.</p>
      
                    <h2>Il rispetto del Codice Etico</h2>
                    <p>
                      Tutti i consulenti che collaborano con Klaro7 devono rispettare il Codice Etico della
                      piattaforma.
                    </p>
                    <p>Questo documento stabilisce regole precise che riguardano:</p>
                    <ul>
                      <li>correttezza nei confronti degli utenti</li>
                      <li>divieto di creare dipendenza emotiva</li>
                      <li>rispetto dei limiti di competenza</li>
                      <li>tutela delle situazioni di vulnerabilità</li>
                      <li>divieto di consulenze su ambiti medici, legali o finanziari</li>
                    </ul>
                    <p>
                      Il rispetto di queste regole è fondamentale per garantire un servizio responsabile.
                    </p>
      
                    <h2>Il sistema di recensioni degli utenti</h2>
                    <p>
                      Uno degli strumenti più importanti per mantenere alta la qualità del servizio è il
                      sistema di recensioni.
                    </p>
                    <p>
                      Dopo ogni consulenza gli utenti possono lasciare una valutazione basata sulla propria
                      esperienza.
                    </p>
                    <p>
                      Le recensioni contribuiscono a creare un ranking interno dei consulenti, che permette
                      di evidenziare i professionisti più apprezzati dagli utenti.
                    </p>
                    <p>Questo sistema premia:</p>
                    <ul>
                      <li>professionalità</li>
                      <li>capacità di ascolto</li>
                      <li>qualità delle interpretazioni</li>
                      <li>correttezza nel rapporto con il consultante</li>
                    </ul>
      
                    <h2>Monitoraggio della qualità del servizio</h2>
                    <p>
                      Klaro7 monitora costantemente la qualità delle consulenze offerte sulla piattaforma.
                    </p>
                    <p>
                      Qualora emergano comportamenti non conformi agli standard richiesti, la piattaforma
                      può adottare diversi provvedimenti, tra cui:
                    </p>
                    <ul>
                      <li>richiami formali</li>
                      <li>sospensione temporanea dell&apos;account</li>
                      <li>cessazione della collaborazione</li>
                    </ul>
                    <p>
                      Questo sistema permette di garantire agli utenti un ambiente affidabile e controllato.
                    </p>
      
                    <h2>Un impegno verso gli utenti</h2>
                    <p>
                      Il processo di selezione e monitoraggio dei consulenti è parte dell&apos;impegno di
                      Klaro7 nel costruire una piattaforma basata su:
                    </p>
                    <ul>
                      <li>trasparenza</li>
                      <li>professionalità</li>
                      <li>rispetto degli utenti</li>
                      <li>qualità delle consulenze</li>
                    </ul>
                    <p>
                      Grazie a questo approccio, Klaro7 punta a diventare un punto di riferimento per chi
                      desidera confrontarsi con consulenti seri in un ambiente sicuro e professionale.
                    </p>
    </LegalPageLayout>
  );
}
